export type WebMcpActor = 'agent' | 'user';

export interface WebMcpProvenanceArgs {
    readonly action: string
    readonly target?: string
    readonly name?: string
    readonly frame?: number
    readonly fps?: number
    readonly url?: string
    readonly structureRef?: string
}

export interface WebMcpProvenanceEntry {
    readonly id: string
    readonly at: number
    readonly actor: WebMcpActor
    readonly tool: string
    readonly args: WebMcpProvenanceArgs
    readonly summary: string
}

/** In-memory audit trail for accepted WebMCP mutations. */
export class WebMcpProvenanceLog {
    private readonly entries: WebMcpProvenanceEntry[] = [];
    private nextId = 1;

    add(actor: WebMcpActor, tool: string, args: WebMcpProvenanceArgs, summary: string, at = Date.now()): WebMcpProvenanceEntry {
        const entry: WebMcpProvenanceEntry = { id: `provenance-${this.nextId++}`, at, actor, tool, args, summary };
        this.entries.unshift(entry);
        return entry;
    }

    list(limit = 50): readonly WebMcpProvenanceEntry[] {
        return this.entries.slice(0, Math.max(0, limit));
    }
}
